import { gql } from '@apollo/client'

/**
 * Persists the shopper's pick for one checkout rule onto their session.
 *
 * The write half of what `CartCheckoutPanel` reads. Server-side this reaches
 * `Session.setCheckoutRuleById`, which filters out any existing entry for the
 * same `ruleType` and appends — so the array holds at most one entry per type
 * and calling this twice replaces rather than accumulates. The order copies
 * the session's selections at create time.
 *
 * ⚠️ **`value` is a leaf in both directions.** The argument is `JSON!` and the
 * returned field is `JSON`, so `value { data amount }` is a
 * `FieldsOnCorrectType` error that fails the whole document. Send the object
 * as a variable; select the field bare. `tests/mutation.test.ts` pins this
 * against the parsed AST.
 *
 * ⚠️ **`sessionUid` is `String!` here, not `ID!`.** `getCheckoutRule` declares
 * the same argument as `ID!`. The schema is inconsistent and each operation's
 * variable declaration matches its own field rather than the other's.
 * @internal
 */
const setCheckoutRuleSessionMutation = gql`
  mutation SetCheckoutRuleSession(
    $storefrontName: String!
    $sessionUid: String!
    $ruleType: String!
    $value: JSON!
  ) {
    setCheckoutRuleSession(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      ruleType: $ruleType
      value: $value
    ) {
      ruleType
      value
    }
  }
`

export default setCheckoutRuleSessionMutation
